import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetProductModalSupplierDetailsDocument = gql`
  query GetProductModalSupplierDetails($tradeRelationshipId: Int!) {
    tradeRelationship(id: $tradeRelationshipId) {
      id
      supplier {
        id
        name
        billingAddressLine1
        billingAddressLine2
        billingAddressCity
        billingAddressStateProvince
        billingAddressPostalCode
        telephone
        email
        supplierRelationship {
          id
          preferredSupplier
        }
      }
    }
  }
` as unknown as DocumentNode<
  Types.GetProductModalSupplierDetailsQuery,
  Types.GetProductModalSupplierDetailsQueryVariables
>
